function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMediaCard4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1017 463",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 1017,
    height: 463,
    style: {
      fill: "#2a38f8",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 653,
    cy: 230,
    r: 6,
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 673,
    cy: 230,
    r: 6,
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 693,
    cy: 230,
    r: 6,
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M905,240l5.33-21h8.89c4.17,0,6.82,2.64,6.82,6.09,0,3.24-2.28,5.94-5.79,7.08l2.28,7.83h-6.09l-1.86-7.26h-2.01l-1.86,7.26h-5.72ZM913.71,228.3h3.35c1.83,0,3.14-1.35,3.14-2.91,0-1.14-.79-1.89-1.86-1.89h-3.41l-1.22,4.8Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M928.22,240l4.11-16.2h-5.63l1.22-4.8h17.05l-1.22,4.8h-5.63l-4.11,16.2h-5.79Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M941.03,240l5.3-21h5.54l4.54,12.3,2.95-12.3h5.63l-5.3,21h-5.54l-4.57-12.3-2.89,12.3h-5.67Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.28,171.2c-32.64,0-56.48-24.8-56.48-59.2s23.84-59.2,56.48-59.2,56.64,24.8,56.64,59.2-24,59.2-56.64,59.2ZM80.8,112c0,26.08,17.12,45.12,40.48,45.12s40.48-19.04,40.48-45.12-16.96-45.28-40.48-45.28-40.48,19.04-40.48,45.28ZM195.74,168V56h43.52c22.56,0,38.4,15.2,38.4,35.52s-15.84,35.68-38.4,35.68h-27.68v40.8h-15.84ZM211.59,114.56h26.24c13.92,0,23.68-9.6,23.68-23.04s-9.76-22.88-23.68-22.88h-26.24v45.92ZM293.52,168V56h43.52c22.56,0,38.4,15.2,38.4,35.52s-15.84,35.68-38.4,35.68h-27.68v40.8h-15.84ZM309.36,114.56h26.24c13.92,0,23.68-9.6,23.68-23.04s-9.76-22.88-23.68-22.88h-26.24v45.92ZM446.01,171.2c-32.64,0-56.48-24.8-56.48-59.2s23.84-59.2,56.48-59.2,56.64,24.8,56.64,59.2-24,59.2-56.64,59.2ZM405.53,112c0,26.08,17.12,45.12,40.48,45.12s40.48-19.04,40.48-45.12-16.96-45.28-40.48-45.28-40.48,19.04-40.48,45.28ZM520.48,168V56h44.64c22.08,0,37.92,14.08,37.92,33.6,0,16-10.24,28.16-25.6,32.32l27.2,46.08h-17.92l-25.28-44.48h-25.28v44.48h-15.68ZM536.16,111.04h28.16c13.12,0,22.56-8.96,22.56-21.28s-9.44-21.12-22.56-21.12h-28.16v42.4Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.04,410v-2.56l9.76-.64,3.84-2.08,26.24-106.08-17.92-1.28-16.32,29.76h-3.2l10.4-33.44h2.72l7.2,1.12h44.32l7.84-1.12h2.72l-1.12,33.44h-2.88l-5.76-29.6-17.12.96-26.08,106.24,3.84,2.08,9.6.64v2.56h-38.08ZM521.36,412.4c-17.44,0-28.8-12.96-20.32-46.72l16.48-65.6-3.2-2.08-7.68-.64v-2.56h36.16v2.56l-10.24.64-4,2.08-17.12,67.52c-7.04,28.16,1.44,38.08,13.92,38.08s22.4-9.92,28.96-36.96l17.12-68.64-3.52-2.08-9.12-.64v-2.56h28.96v2.56l-8.16.64-3.2,2.08-16.8,67.36c-8.32,33.44-21.76,44.96-38.24,44.96ZM625.05,410l-19.04-103.68-24,98.4,4.16,2.08,10.08.64v2.56h-29.92v-2.56l7.84-.64,3.04-2.08,26.4-105.6-10.24-2.08v-2.24h21.76l18.88,104.32,24.32-99.04-4-2.08-10.08-.64v-2.56h29.92v2.56l-7.84.64-3.04,2.08-27.52,109.92h-10.72ZM654.73,410v-2.56l8.32-.64,3.36-2.08,26.24-104.64-3.2-2.08-8.16-.64v-2.56h34.08v2.56l-8.48.64-3.2,2.08-26.24,104.64,3.2,2.08,8.16.64v2.56h-34.08ZM711.77,410v-2.56l9.76-.64,3.84-2.08,26.24-106.08-17.92-1.28-16.32,29.76h-3.2l10.4-33.44h2.72l7.2,1.12h44.32l7.84-1.12h2.72l-1.12,33.44h-2.88l-5.76-29.6-17.12.96-26.08,106.24,3.84,2.08,9.6.64v2.56h-38.08ZM772.16,410v-2.56l8.32-.64,3.36-2.08,26.24-104.64-3.2-2.08-8.16-.64v-2.56h34.08v2.56l-8.48.64-3.2,2.08-26.24,104.64,3.2,2.08,8.16.64v2.56h-34.08ZM815.88,410v-2.56l7.84-.64,3.04-2.08,26.24-104.64-3.04-2.08-7.68-.64v-2.56h56.8v28.96h-3.04l-7.04-24.96h-24.8l-12.32,49.6h13.12l16.16-2.24h2.88v8.96h-2.88l-16.16-2.4h-14.24l-13.28,53.28h28.32l17.28-27.84h2.88l-10.24,31.84h-59.84ZM916.86,412.24c-10.56,0-19.2-4.48-25.44-11.84l3.36-26.4h3.36l.8,9.76c1.92,18.72,10.72,24.64,19.52,24.64,12.96,0,22.4-11.52,22.4-25.76,0-8.16-3.04-14.88-9.28-22.08l-11.04-11.2c-6.72-7.52-10.72-14.4-10.72-24.32,0-18.4,14.4-32.48,32.48-32.48,8.96,0,16.64,3.68,23.2,10.56l-3.2,25.28h-3.2l-.8-9.28c-1.6-15.52-8-23.04-17.92-23.04-11.52,0-20,9.6-20,23.2,0,8.8,3.52,15.52,9.44,22.24l11.2,11.68c6.88,7.68,10.56,13.92,10.56,23.36,0,20.16-14.88,35.68-34.72,35.68Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 18,
    width: 981,
    height: 427,
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19,
    y1: 206,
    x2: 999,
    y2: 206,
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 373,
    y1: 253,
    x2: 999,
    y2: 253,
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.46,240.42c-4.41,0-7.26-3.36-7.26-8.31,0-5.7,3.63-13.53,10.47-13.53,4.5,0,7.29,3.39,7.29,8.34,0,5.85-3.78,13.5-10.5,13.5ZM410.75,231.96c0,2.16.75,3.63,2.1,3.63,3,0,4.56-5.82,4.56-8.49,0-2.16-.72-3.69-2.1-3.69-3,0-4.56,5.88-4.56,8.55ZM430.13,240l1.02-4.05h-9l.96-3.96c3.87-3.21,7.77-7.95,9.78-13.14h6c-1.86,5.31-6.36,10.41-10.89,12.9h4.5l1.02-4.05h4.86l-1.02,4.05h2.64l-1.05,4.2h-2.64l-1.02,4.05h-5.16Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 656,
    y1: 18,
    x2: 656,
    y2: 205,
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 371,
    y1: 206,
    x2: 371,
    y2: 446,
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 471,
    y1: 206,
    x2: 471,
    y2: 253,
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 871,
    y1: 206,
    x2: 871,
    y2: 253,
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827.5,177c-73.61,0-133.5-29.61-133.5-66s59.9-66,133.5-66c.31,0,.61,0,.92,0,.15,0,.3,0,.45,0,.44,0,.87,0,1.31.01,72.37.71,130.82,30.04,130.82,65.99s-58.44,65.28-130.82,65.99c-.43,0-.87.01-1.31.01h-.13c-.1,0-.21,0-.32,0-.31,0-.61,0-.92,0ZM799.38,169.86c-56.95-6.07-99.61-30.15-99.61-58.86s42.66-52.8,99.61-58.86c-21.19,10.91-35.74,33.2-35.74,58.86s14.55,47.95,35.74,58.86ZM859.12,169.46c55.19-6.66,96.12-30.35,96.12-58.46s-40.92-51.8-96.12-58.46c20.78,11.05,34.98,33.11,34.98,58.46s-14.2,47.41-34.98,58.46ZM811.47,53.03c-12.29,3.77-22.93,11.43-30.49,21.56,3.77,2.58,8.22,4.74,13.12,6.49,1.4-4.75,3.15-9.16,5.21-13.1,3.38-6.47,7.47-11.48,12.16-14.94ZM826.13,52.75c-13.09,1.47-22.14,13.82-26.92,29.95,8.29,2.34,17.57,3.61,26.92,3.81v-33.75ZM792.77,86.14c-5.62-1.95-10.62-4.36-14.76-7.19-5.41,8.74-8.68,18.97-9.05,29.92h21.04c.17-7.98,1.12-15.67,2.77-22.74ZM795.28,108.88c.17-7.23,1.04-14.43,2.6-21.14,8.53,2.38,18.18,3.77,28.25,3.98v17.17h-30.85ZM790,114.17h-21c.56,10.87,3.97,20.99,9.49,29.61,4.15-2.76,8.98-5.07,14.27-6.92-1.64-7.06-2.59-14.73-2.76-22.69ZM797.86,135.26c-1.55-6.7-2.42-13.87-2.59-21.08h30.85v17.08c-9.8.2-19.52,1.54-28.27,4.01ZM794.11,142c-4.68,1.66-8.93,3.69-12.58,6.1,7.05,9.15,16.63,16.21,27.68,20.1-3.75-3.32-7.07-7.7-9.89-13.1-2.06-3.94-3.8-8.35-5.2-13.1ZM826.13,170.32c-13.08-1.47-22.14-13.81-26.92-29.93,8.29-2.33,17.56-3.59,26.92-3.79v33.72ZM858.24,67.97c-3.4-6.52-7.54-11.55-12.27-15.02,12.38,3.73,23.09,11.39,30.71,21.55-3.79,2.62-8.28,4.81-13.24,6.57-1.4-4.75-3.15-9.15-5.2-13.1ZM831.41,52.74c13.1,1.46,22.16,13.81,26.94,29.94-8.29,2.34-17.57,3.61-26.94,3.81v-33.76ZM862.28,108.88c-.17-7.24-1.05-14.44-2.61-21.16-8.53,2.38-18.18,3.77-28.26,3.98v17.18h30.87ZM864.78,86.12c1.66,7.07,2.6,14.77,2.78,22.75h21.23c-.37-11-3.67-21.26-9.12-30.02-4.17,2.85-9.21,5.3-14.89,7.26ZM831.41,114.17h30.87c-.16,7.42-1.03,14.55-2.52,21.1-8.77-2.48-18.52-3.82-28.35-4.02v-17.08ZM867.56,114.17c-.17,7.96-1.11,15.63-2.76,22.69,5.35,1.87,10.22,4.21,14.4,7.01,5.55-8.64,8.98-18.79,9.55-29.7h-21.18ZM831.41,136.6c9.39.2,18.7,1.47,27.01,3.81-1.31,4.45-2.93,8.56-4.85,12.23-3.94,7.56-10.91,16.47-22.16,17.68v-33.73ZM858.24,155.1c-2.85,5.46-6.21,9.88-10.01,13.21,11.14-3.85,20.8-10.92,27.91-20.11-3.67-2.45-7.97-4.51-12.7-6.19-1.4,4.75-3.14,9.15-5.2,13.09Z",
    style: {
      fill: "#0e0e0e",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(40.16 296.8) scale(.71)",
    style: {
      fontFamily: "StabilGrotesk-Regular, &apos",
      fontSize: "28.19px"
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      letterSpacing: "0em"
    }
  }, "O"), /*#__PURE__*/React.createElement("tspan", {
    x: 22.75,
    y: 0,
    style: {
      letterSpacing: "0em"
    }
  }, "p"), /*#__PURE__*/React.createElement("tspan", {
    x: 39.57,
    y: 0,
    style: {
      letterSpacing: "0em"
    }
  }, "po"), /*#__PURE__*/React.createElement("tspan", {
    x: 72.63,
    y: 0,
    style: {
      letterSpacing: "0em"
    }
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 82.92,
    y: 0,
    style: {
      letterSpacing: "0em"
    }
  }, "tun"), /*#__PURE__*/React.createElement("tspan", {
    x: 123.96,
    y: 0,
    style: {
      letterSpacing: "-.01em"
    }
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    x: 129.65,
    y: 0,
    style: {
      letterSpacing: "0em"
    }
  }, "ties "), /*#__PURE__*/React.createElement("tspan", {
    x: 181.09,
    y: 0,
    style: {
      letterSpacing: "-.03em"
    }
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 191.24,
    y: 0,
    style: {
      letterSpacing: "0em"
    }
  }, "o "), /*#__PURE__*/React.createElement("tspan", {
    x: 213,
    y: 0,
    style: {
      letterSpacing: "-.03em"
    }
  }, "w"), /*#__PURE__*/React.createElement("tspan", {
    x: 236.05,
    y: 0,
    style: {
      letterSpacing: "0em"
    }
  }, "ork "), /*#__PURE__*/React.createElement("tspan", {
    x: 282.89,
    y: 0,
    style: {
      letterSpacing: "-.03em"
    }
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 293.04,
    y: 0,
    style: {
      letterSpacing: "0em"
    }
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    x: 309.47,
    y: 0,
    style: {
      letterSpacing: "0em"
    }
  }, "g"), /*#__PURE__*/React.createElement("tspan", {
    x: 326.47,
    y: 0,
    style: {
      letterSpacing: "-.02em"
    }
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    x: 342,
    y: 0,
    style: {
      letterSpacing: "0em"
    }
  }, "ther on "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 33.9,
    style: {
      letterSpacing: "0em"
    }
  }, "no"), /*#__PURE__*/React.createElement("tspan", {
    x: 31.65,
    y: 33.9,
    style: {
      letterSpacing: "0em"
    }
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    x: 46.98,
    y: 33.9,
    style: {
      letterSpacing: "0em"
    }
  }, "-"), /*#__PURE__*/React.createElement("tspan", {
    x: 57.89,
    y: 33.9,
    style: {
      letterSpacing: "0em"
    }
  }, "comme"), /*#__PURE__*/React.createElement("tspan", {
    x: 155.19,
    y: 33.9,
    style: {
      letterSpacing: "-.03em"
    }
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 164.63,
    y: 33.9,
    style: {
      letterSpacing: "0em"
    }
  }, "ci"), /*#__PURE__*/React.createElement("tspan", {
    x: 186.16,
    y: 33.9,
    style: {
      letterSpacing: "0em"
    }
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    x: 200.57,
    y: 33.9,
    style: {
      letterSpacing: "0em"
    }
  }, "l or a"), /*#__PURE__*/React.createElement("tspan", {
    x: 259.7,
    y: 33.9,
    style: {
      letterSpacing: "0em"
    }
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 269.99,
    y: 33.9,
    style: {
      letterSpacing: "0em"
    }
  }, "ti"), /*#__PURE__*/React.createElement("tspan", {
    x: 286.36,
    y: 33.9,
    style: {
      letterSpacing: "0em"
    }
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    x: 300.09,
    y: 33.9,
    style: {
      letterSpacing: "0em"
    }
  }, "tic p"), /*#__PURE__*/React.createElement("tspan", {
    x: 354.37,
    y: 33.9,
    style: {
      letterSpacing: "-.03em"
    }
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 363.84,
    y: 33.9,
    style: {
      letterSpacing: "0em"
    }
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    x: 380.3,
    y: 33.9,
    style: {
      letterSpacing: "0em"
    }
  }, "j"), /*#__PURE__*/React.createElement("tspan", {
    x: 386.33,
    y: 33.9,
    style: {
      letterSpacing: "0em"
    }
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    x: 402.23,
    y: 33.9,
    style: {
      letterSpacing: "-.01em"
    }
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 417.87,
    y: 33.9,
    style: {
      letterSpacing: "-.01em"
    }
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 428.33,
    y: 33.9,
    style: {
      letterSpacing: "0em"
    }
  }, "s "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 67.79,
    style: {
      letterSpacing: "0em"
    }
  }, "w"), /*#__PURE__*/React.createElement("tspan", {
    x: 23.65,
    y: 67.79,
    style: {
      letterSpacing: "-.01em"
    }
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    x: 29.34,
    y: 67.79,
    style: {
      letterSpacing: "0em"
    }
  }, "th RM and "), /*#__PURE__*/React.createElement("tspan", {
    x: 159.73,
    y: 67.79,
    style: {
      letterSpacing: "-.02em"
    }
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    x: 175.65,
    y: 67.79,
    style: {
      letterSpacing: "0em"
    }
  }, "ther membe"), /*#__PURE__*/React.createElement("tspan", {
    x: 330.73,
    y: 67.79,
    style: {
      letterSpacing: "-.01em"
    }
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 340.62,
    y: 67.79,
    style: {
      letterSpacing: "0em"
    }
  }, "s "), /*#__PURE__*/React.createElement("tspan", {
    x: 359.79,
    y: 67.79,
    style: {
      letterSpacing: "-.02em"
    }
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    x: 375.74,
    y: 67.79,
    style: {
      letterSpacing: "0em"
    }
  }, "f the "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 101.69,
    style: {
      letterSpacing: "0em"
    }
  }, "commun"), /*#__PURE__*/React.createElement("tspan", {
    x: 111.81,
    y: 101.69,
    style: {
      letterSpacing: "-.01em"
    }
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    x: 117.5,
    y: 101.69,
    style: {
      letterSpacing: "0em"
    }
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 128.13,
    y: 101.69,
    style: {
      letterSpacing: "-.1em"
    }
  }, "y"), /*#__PURE__*/React.createElement("tspan", {
    x: 141.24,
    y: 101.69,
    style: {
      letterSpacing: "0em"
    }
  }, ".")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaCard4);
export default __webpack_public_path__ + "static/media/media-card-4.5b0a5fc8df74dcf9ddfeb59309d08aff.svg";
export { ForwardRef as ReactComponent };